module.exports = __webpack_public_path__ + "img/icon-warning.b0d43ac4.svg";